export const TEAM = [
  { name: "Akshay Jindal", role: "Founder", photo: "founder.jpg" },
  { name: "Inderpal Singh", role: "Senior Google Street View Photographer", photo: "inderpal.jpg" },
  { name: "Advocate Harman Sidhu", role: "Head of Legal & Compliance", photo: "harman.jpg" },
  { name: "Yogesh Garg", role: "Head of Social Media Marketing", photo: "yogesh.jpg" },
  { name: "Anil", role: "360° Virtual Tour Specialist", photo: "anil.jpg" },
  { name: "Priya", role: "Content Marketing Specialist", photo: "priya.jpg" },
  { name: "Kamal", role: "Digital Marketing Executive", photo: "kamal.jpg" },
  { name: "Deepinder Bhandari", role: "Web Developer", photo: "deepinder.jpg" },
];

export const teamPhoto = (m) => `/assets/team/${m.photo}`;

export const teamSlug = (m) => m.photo.replace(".jpg", "").replace("../", "");
